import React from "react";
import Button from "../../../components/common/Button";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import { useHistory } from "react-router-dom";

const AmenitiesModel = ({ open, handleClose }) => {
  let history = useHistory();
  return (
    <>
      <Dialog
        maxWidth={"xs"}
        open={open}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
       
      >
        <Stack
          spacing={2}
          sx={{ justifyContent: "center", alignItems: "center", p: 4.5 }}
        >
          <img src="../images/Group 67505.png" alt="logo" />
          <Typography
            sx={{ fontSize: "18px", fontWeight: "600", textAlign: "center" }}
          >
            Coupon code<br></br> generated successfully.
          </Typography>
          <Button
            fullWidth
            variant="contained"
            onClick={() => {handleClose(); history.goBack()}}
            children="Ok"
          />
        </Stack>
      </Dialog>
    </>
  );
};

export default AmenitiesModel;
